import React, { useState } from "react";
import { FilterValue, HvFilterGroup } from "@hitachivantara/uikit-react-core";
import { useTranslation } from "react-i18next";
import { useCategories, useSubCategories } from "lib/api";
import useStyles from "./styles";

interface IncidentTypeFilter {
  onChange: (value: string[][]) => void;
}

const IncidentTypeFilter: React.FC<IncidentTypeFilter> = ({ onChange }) => {
  const classes = useStyles();
  const { t } = useTranslation(["incidentType", "common"]);
  const [value, setValue] = useState<string[][]>([]);

  const { data: categoriesData } = useCategories(undefined, {
    revalidateOnFocus: false,
  });

  const { data: subCategoriesData } = useSubCategories(undefined, {
    revalidateOnFocus: false,
  });

  const categoriesDataFilter = categoriesData?.data.map((category) => ({
    id: category.pk_cat_id,
    name: category.cat_name,
  }));

  const subCategoriesDataFilter = subCategoriesData?.data.map(
    (subcategory) => ({
      id: subcategory.pk_sub_cat_id,
      name: subcategory.sub_cat_name,
    })
  );

  const filters = [
    {
      id: "category",
      name: t("incidentType:filter.category"),
      data: categoriesDataFilter === undefined ? [] : categoriesDataFilter,
    },
    {
      id: "subcategory",
      name: t("incidentType:filter.subcategory"),
      data:
        subCategoriesDataFilter === undefined ? [] : subCategoriesDataFilter,
    },
  ];

  const onChangeHandler = (event: Event, values: FilterValue) => {
    const newValues = values as string[][];
    setValue(newValues);
    onChange(newValues);
  };

  return (
    <HvFilterGroup
      id="incidentTypeFilter"
      labels={{
        applyLabel: t("common:filter.apply"),
        cancelLabel: t("common:filter.cancel"),
        clearLabel: t("common:filter.clearFilters"),
        placeholder: t("common:filter.filters"),
        searchBoxPlaceholder: t("common:filter.search"),
        selectAll: t("common:filter.all"),
      }}
      value={value}
      filters={filters}
      onChange={onChangeHandler}
      className={classes.filter}
    />
  );
};

export default IncidentTypeFilter;
